import { render, staticRenderFns } from "./StatCard.vue?vue&type=template&id=5b132e36&scoped=true&"
import script from "./StatCard.vue?vue&type=script&lang=js&"
export * from "./StatCard.vue?vue&type=script&lang=js&"
import style0 from "./StatCard.vue?vue&type=style&index=0&id=5b132e36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b132e36",
  null
  
)

export default component.exports